export default "__VITE_ASSET__833e3cdd__"